<template>
  <div class="footer">
    <div class="inner">
      <img src="@/assets/logo.png" alt="" />
      <p>Copyright 2018 LongtuGame All Right Reserved</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  background: #353535;
  .inner {
    width: 1200px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
    margin: 0 auto;
    img {
      padding-right: 50px;
    }
    p {
      font-size: 12px;
      color: #d4d4d4;
    }
  }
}
@media screen and (max-width: 960px) {
  .footer {
    .inner {
      width: 100%;
      padding: 20px 0;
      img {
        padding-right: 10px;
        width: 100px;
      }
    }
  }
}
</style>
